import { render, staticRenderFns } from "./ConfigBox.vue?vue&type=template&id=759495c7"
import script from "./ConfigBox.vue?vue&type=script&lang=js"
export * from "./ConfigBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports